import { ERROR_CODE as P } from "../../constants/error.js";
import { CustomError as v } from "../../errors/customError.js";
import { createStrictContext as N } from "../../util/context/createStrictContext.js";
import { useRouter as Q } from "next/router";
import l from "query-string";
import * as r from "ramda";
import { useRef as U, useState as c, useCallback as R, useEffect as m } from "react";
import { jsx as w } from "react/jsx-runtime";
const [S, L] = N("PersistQuery"), T = (d) => {
  const {
    children: C
  } = d, t = Q(), g = U([]), [i, h] = c([]), a = R((e, n) => !r.whereEq(e)(n), []), s = R((e) => r.pipe(r.pick(i), r.reject(r.isNil))(e), [i]), [u, f] = c(null), [o, q] = c({});
  return m(() => {
    const e = (n) => {
      const {
        fragmentIdentifier: y,
        query: p,
        url: x
      } = l.parseUrl(n), E = s(p);
      if (a(o, E))
        throw f(l.stringifyUrl({
          fragmentIdentifier: y,
          url: x,
          query: {
            ...p,
            ...o
          }
        })), new v(`missing ${r.keys(o)} on route change, inject it and redirect`, P.UI.ABORT_ROUTE_CHANGE);
    };
    return t.events.on("routeChangeStart", e), () => {
      t.events.off("routeChangeStart", e);
    };
  }, [a, s, i, o, t]), m(() => {
    const e = s(t.query);
    r.isNotEmpty(e) && q(e);
  }, [s, t.query]), m(() => {
    r.isNotNil(u) && (t.push(u), f(null));
  }, [u, t]), /* @__PURE__ */ w(S, {
    value: {
      persistKeysRef: g,
      setPersistKeys: h
    },
    children: C
  });
};
export {
  T as PersistQueryProvider,
  L as usePersistQueryContext
};
//# sourceMappingURL=PersistQueryContext.js.map
